import axios from 'axios'
import { reduce } from 'lodash'
import { useEffect, useRef, useState } from 'react'

import Remote from '../remote'
import { centsToDollars } from '../utils/formatters'

const formatTotal = (total) => {
  let totalInCents
  if (typeof total === 'string') {
    const result = parseFloat(total).toFixed(2) // convert to number and round to 2nd decimal
    totalInCents = result * 100
  } else {
    totalInCents = total * 100
  }
  return centsToDollars(totalInCents)
}


const formatTotals = (totals) => reduce(totals, (formattedTotals, total, key) => {
    return {
      ...formattedTotals,
      [key]: formatTotal(total)
    }
  }, {})

const useGetSummaryReport = () => {
  const [dataLoading, setLoading] = useState(false)
  const [dataSucceeded, setSuccess] = useState(false)
  const [dataFailed, setFailed] = useState(false)
  const [data, setData] = useState()
  const deviceUuid = localStorage.getItem('device_id')
  const cancelTokenRef = useRef()

  useEffect(() => {
    cancelTokenRef.current = axios.CancelToken.source()

    return () => {
      cancelTokenRef.current.cancel()
    }
  }, [])

  const executeRequest = () => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    Remote.getSummaryReport(deviceUuid).then((result) => {
      const data = result?.data?.reports?.[0]
      setData({ ...formatTotals(data.totals ?? {}), pendingRefundCount: data?.unappliedRefundsCount ?? 0 })
      setLoading(false)
      setSuccess(true)
    }).catch((err) => {
      if (axios.isCancel(err)) return

      setLoading(false)
      setFailed(true)
    })
  }

  return [executeRequest, { data, dataLoading, dataSucceeded, dataFailed }]
}

export default useGetSummaryReport
